import type { SVGProps } from "react";

export function IconDarkBlueCart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42 30H12V6H6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M10 38C10 36.9391 10.4214 35.9217 11.1716 35.1716C11.9217 34.4214 12.9391 34 14 34C15.0609 34 16.0783 34.4214 16.8284 35.1716C17.5786 35.9217 18 36.9391 18 38C18 39.0609 17.5786 40.0783 16.8284 40.8284C16.0783 41.5786 15.0609 42 14 42C12.9391 42 11.9217 41.5786 11.1716 40.8284C10.4214 40.0783 10 39.0609 10 38L10 38Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M35 38C35 36.9391 35.4214 35.9217 36.1716 35.1716C36.9217 34.4214 37.9391 34 39 34C40.0609 34 41.0783 34.4214 41.8284 35.1716C42.5786 35.9217 43 36.9391 43 38C43 39.0609 42.5786 40.0783 41.8284 40.8284C41.0783 41.5786 40.0609 42 39 42C37.9391 42 36.9217 41.5786 36.1716 40.8284C35.4214 40.0783 35 39.0609 35 38L35 38Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M18 6H38V26H18V6Z"
        fill="#63B2FF"
        stroke="#63B2FF"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M28 6V11"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
